import React from "react";
import Pedras from '../assets/Pedras.jpeg';


const PedrasPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img src={Pedras} alt="Pedras no Caminho" className="w-full h-auto rounded-lg shadow-lg" />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">As Pedras no Caminho</h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            Ao traçar um planejamento para alcançar um objetivo, muitas vezes as coisas saem do esperado, 
            e isso pode nos gerar raiva, medo, tristeza, angústia.
            <br /><br />
            Arquitetar um caminho a ser seguido nos ajuda a alcançá-lo. Mas se surgirem algumas 
            “pedras no caminho”, tudo bem também. Entenda e acolha seus sentimentos, 
            eles fazem parte de quem você é.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PedrasPage;